import { render, staticRenderFns } from "./OnboardingAthleteSportPosition.vue?vue&type=template&id=411dae54&"
import script from "./OnboardingAthleteSportPosition.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAthleteSportPosition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports